module.exports = __webpack_public_path__ + "media/8.2e20a571.mp3";